<script lang="ts">
</script>

<div class="fizz-container fizz-grid-center fizz-stack-24">
  <div class="fizz-alert-info">
    <p><strong>View Only</strong> You don't have access to pay an invoice</p>
  </div>
</div>
